/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Listing_CodeInputs */

const cs_form_listing_code = /** @type {(inputs: Form_Listing_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kód zakázky`)
};

const en_form_listing_code = /** @type {(inputs: Form_Listing_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing code`)
};

/**
* | output |
* | --- |
* | "Listing code" |
*
* @param {Form_Listing_CodeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_listing_code = /** @type {((inputs?: Form_Listing_CodeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Listing_CodeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_listing_code(inputs)
	return cs_form_listing_code(inputs)
});